import React from 'react';

const defaultTerms = [
  {
    id: 1,
    title: 'Promotion Sponsor',
    content: `This promotion is organized and managed by the Promotion Organizer (hereinafter referred to as the "Organizer"). Full sponsor details are available upon request.`
  },
  {
    id: 2,
    title: 'Excluded Participants',
    content: `All employees, contractors and their immediate families of the Organizer, its affiliates, promotional partners, and any third party involved in the development or execution of this Promotion shall not be eligible to participate.`
  },
  {
    id: 3,
    title: 'Duration',
    content: `The Promotion will run for the period specified by the Organizer. It will be valid while prizes last, provided that the Organizer has not exhausted the available Prizes. Please refer to the campaign details for specific start and end dates.`
  },
  {
    id: 4,
    title: 'How to Participate',
    content: `To participate, eligible participants must:\n• Purchase a qualifying promotional product\n• Find the unique promotional code on the product\n• Register your details on this platform\n• Enter your unique code\n• Stand a chance to win amazing prizes\n\nPrizes are completely randomized and subject to availability.`
  },
  {
    id: 5,
    title: 'Prizes',
    content: `Participants are eligible to win prizes as specified in the promotion details. The Organizer reserves the right to substitute prizes of equal or greater value. Prizes are non-transferable and non-exchangeable.`
  },
  {
    id: 6,
    title: 'Entry Conditions',
    content: `• Codes are valid for single use. Lost codes cannot be regenerated.\n• Participants will not be charged a fee to access this promotion platform.\n• Unclaimed prizes will be forfeited after the specified redemption period.\n• Participants may enter as many times as they have valid unique codes.`
  },
  {
    id: 7,
    title: 'Eligibility',
    content: `The Promotion is open to residents who meet the eligibility criteria specified by the Organizer. Participants must be 18 years of age or older at the time of entry. Failure to meet eligibility requirements will result in disqualification.`
  },
  {
    id: 8,
    title: 'Personal Data',
    content: `By participating, you consent to the collection, use, and processing of your personal information by the Organizer for the purposes of administering this Promotion. Your data will be handled in accordance with applicable data protection laws. The Organizer will never request money or additional compensation from participants.`
  },
  {
    id: 9,
    title: 'Limitation of Liability',
    content: `The Organizer shall not be liable for any loss or damage arising from participation in the Promotion, including but not limited to technical failures, network issues, or force majeure events. The Organizer reserves the right to amend these terms at any time.`
  },
  {
    id: 10,
    title: 'Governing Law',
    content: `These Terms and Conditions shall be governed by and construed in accordance with applicable laws. By entering the Promotion, all Participants agree to be bound by these Terms and Conditions.`
  }
];

/**
 * TermsContent — global widget.
 * Priority: explicit `items` prop > brand-config `terms_content` > hardcoded defaults.
 */
const TermsContent = ({ items, heading, introText } = {}) => {
  const terms = items?.length > 0 ? items : defaultTerms;

  return (
    <div className="container">
      <div className="card white-card border-0 rounded-3 mx-auto mb-4">
        <div className="card-body">
          <div className="text-center">
            <h6 className="mb-2 text-decoration-underline">
              {heading || 'TERMS AND CONDITIONS GOVERNING PARTICIPATION IN THIS PROMOTION (The "Promotion")'}
            </h6>
            <p className="font-light" style={{ fontSize: '0.75em' }}>
              {introText ||
                'The following terms and conditions apply exclusively to the Promotion and all Participants in the Promotion are deemed to have read, understood, and accepted the same:'}
            </p>
          </div>

          {terms.map((term) => (
            <div key={term.id} className="my-4">
              <h6 className="mb-2">
                {String(term.id).padStart(2, '0')}. {term.title}
              </h6>
              <div
                className="font-light mb-0 rich-text-content"
                style={{ fontSize: '0.85em', whiteSpace: 'pre-line', lineHeight: '1.6' }}
                dangerouslySetInnerHTML={{ __html: term.content }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsContent;
